import React from 'react';
import cx from 'classnames';
import { KeyValue, MeetingStatus } from './types';
import EventLabel from '../../components/EventLabel/EventLabel';

const secondaryStatusColor: KeyValue = {
  calendar: 'lg:bg-neutral-100',
  [MeetingStatus.BOOKED]: 'lg:bg-green-500 ',
  [MeetingStatus.PENDING]: 'lg:bg-sky-500 ',
  [MeetingStatus.CANCELLED]: 'lg:bg-red-500',
  [MeetingStatus.UNBOOKABLE]: 'lg:bg-amber-500',
};

const statusIcons: KeyValue = {
  calendar: 'ri-calendar-line',
  [MeetingStatus.BOOKED]: 'ri-check-line',
  [MeetingStatus.PENDING]: 'ri-time-line',
  [MeetingStatus.CANCELLED]: 'ri-close-line',
  [MeetingStatus.UNBOOKABLE]: 'ri-calendar-close-line',
  default: 'ri-calendar-close-line',
};

const statusColors: KeyValue = {
  [MeetingStatus.BOOKED]: 'text-green-500 lg:text-white',
  [MeetingStatus.PENDING]: 'text-sky-500 lg:text-white',
  [MeetingStatus.CANCELLED]: 'text-red-500 lg:text-white',
  [MeetingStatus.UNBOOKABLE]: 'text-amber-500 lg:text-white',
};

const labels: KeyValue = {
  [MeetingStatus.BOOKED]: 'MeetingBooked',
  [MeetingStatus.PENDING]: 'MeetingRequest',
  [MeetingStatus.CANCELLED]: 'MeetingCancelled',
};

export default function StatusBadge({ status, isRequested }: { status: MeetingStatus; isRequested: boolean }) {
  return (
    <span className={cx('flex items-center font-normal justify-center text-xs w-fit rounded-full lg:pr-3 gap-x-1 px-1 py-1', secondaryStatusColor[status])}>
      <i className={cx(statusIcons?.[status], statusColors[status], 'lg:ml-2')} />
      <span className={cx('text-xs text-white lg:text-md hidden lg:flex')}>
        <EventLabel name={labels[status as string] ?? status} groupName="CMS.MatchMaking" />
      </span>
    </span>
  );
}
